import React, { useEffect } from 'react';
import { APP_PATH } from 'config';
import { useDispatch } from 'react-redux';
import { setTaskItemRedux } from 'reducers/Login/action';
var Breadcrumb = function (props) {
    var dispatch = useDispatch();
    var urlPath = props.urlPath, applicationCode = props.applicationCode, taskItem = props.taskItem;
    useEffect(function () {
        dispatch(setTaskItemRedux(taskItem));
    }, [applicationCode, taskItem]);
    var breadcrumbShow = function () {
        var style = {
            color: '#0086da',
            fontSize: '1.2em',
            fontWeight: 'bold',
        };
        if (urlPath === APP_PATH + "/homepage") {
            return React.createElement("span", { style: style }, "\u9996\u9801");
        }
        var first = '首頁';
        if (applicationCode && taskItem) {
            return (React.createElement(React.Fragment, null,
                React.createElement("span", null, first + "  /  " + applicationCode + "  /  "),
                React.createElement("span", { style: style }, taskItem.taskName)));
        }
        if (applicationCode) {
            return (React.createElement(React.Fragment, null,
                React.createElement("span", null, first + "  /  "),
                React.createElement("span", { style: style }, applicationCode)));
        }
        return React.createElement("span", { style: style }, first);
    };
    return (React.createElement("div", { style: {
            // width: "200px",
            // float: "right",
            padding: '5px 10px 5px 10px',
        } }, breadcrumbShow()));
};
export default Breadcrumb;
